export default "__VITE_ASSET__D01SBwhF__"